import script from "./ProductListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductListView.vue?vue&type=script&setup=true&lang=js"

import "./ProductListView.vue?vue&type=style&index=0&id=38c4dbae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c4dbae"]])

export default __exports__